import React from 'react'
import { Switch, Route } from 'react-router-dom'

import List from './List'
import New from './New'
import Detail from './Detail'
import Run from './Run'
import ConfigureStep from './Configure/Step'
import Configure from './Configure'
import AddStep from './AddStep'

export default function Actions() {
  return (
    <Switch>
      <Route exact path="/actions" component={List} />
      <Route path="/actions/new" component={New} />
      <Route path="/actions/:id/steps/:stepId" component={ConfigureStep} />
      <Route path="/actions/:id/configure" component={Configure} />
      <Route path="/actions/:id/add-step" component={AddStep} />
      <Route path="/actions/:id/run" component={Run} />
      <Route path="/actions/:id" component={Detail} />
    </Switch>
  )
}
